import { lowerCase } from '@rygen/rygen-ui/i18n';
import { alphabeticComparator } from '@rygen/rygen-ui/util';

import { WellKnownService } from '@/model/rate/WellKnownService';

const sortByName = alphabeticComparator({ isCaseSensitive: false });

/**
 * Placeholder in a priority list for any non-volume service type
 *
 * Includes Guaranteed, Expedited, White Glove, anything that isn’t volume.
 */
const REGULAR_FILTER_PLACEHOLDER = 'any_service_type';

/**
 * Placeholder in a priority list for any volume service type
 *
 * Includes any service type that contains the string _volume_.
 */
const VOLUME_FILTER_PLACEHOLDER = 'volume_service_type';

const FILTERS_PRIORITY_ORDER: Readonly<string[]> = Object.freeze([
  WellKnownService.ALL_AVAILABLE,
  WellKnownService.STANDARD,
  REGULAR_FILTER_PLACEHOLDER,
  VOLUME_FILTER_PLACEHOLDER,
  WellKnownService.UNKNOWN,
]);

const normalizedServiceTypeOrBucket = (str: string) => {
  const serviceType = lowerCase(str);
  if (serviceType === 'std') {
    return WellKnownService.STANDARD;
  } else if (serviceType.includes('volume')) {
    return VOLUME_FILTER_PLACEHOLDER;
  } else {
    return str;
  }
};

export const serviceTypeFilterComparator = (a: string, b: string): number => {
  const aIndex = FILTERS_PRIORITY_ORDER.indexOf(
    normalizedServiceTypeOrBucket(a),
  );
  const bIndex = FILTERS_PRIORITY_ORDER.indexOf(
    normalizedServiceTypeOrBucket(b),
  );

  // List of service types should be distinct so if indices are equal, both `a`
  // and `b` go in the same placeholder slot and can be alphabetized
  if (aIndex === bIndex) {
    return sortByName(a, b);
  } else {
    const newAIndex =
      aIndex === -1
        ? FILTERS_PRIORITY_ORDER.indexOf(REGULAR_FILTER_PLACEHOLDER)
        : aIndex;
    const newBIndex =
      bIndex === -1
        ? FILTERS_PRIORITY_ORDER.indexOf(REGULAR_FILTER_PLACEHOLDER)
        : bIndex;
    return newAIndex - newBIndex;
  }
};
